export function initActionClicks(query = document.querySelectorAll(".js-actionClick")) {
    for (let target of query) {
        let action = target.dataset.action;
        if (action) {
            target.addEventListener("click", function () {
                window.location.href = action;
            });
        }
    }
}

export function initFormSubmitClicks(query = document.querySelectorAll(".js-formSubmitClick")) {
    for (let target of query) {
        target.addEventListener("click", function () {
            // Firefox fires the click on the label before activating the associated
            // control, so display:none radios may not be checked yet — set it explicitly.
            const forId = target.getAttribute("for");
            const radio = forId ? document.getElementById(forId) : target.querySelector('input[type="radio"]');
            if (radio) radio.checked = true;
            target.closest('form').submit();
        });
    }
}

export function initFormSubmitChanges(query = document.querySelectorAll(".js-formSubmitChange")) {
    for (let target of query) {
        target.addEventListener("change", function () {
            target.closest('form').submit();
        });
    }
}